import { initializeApp } from "firebase/app";
import { getAuth, Auth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC1TmMhHXn6I2Sehv-mnvPZvJh1q3bErYA",
  authDomain: "trade-a1284.firebaseapp.com",
  projectId: "trade-a1284",
  storageBucket: "trade-a1284.appspot.com",
  messagingSenderId: "846114417912",
  appId: "1:846114417912:web:9084255d5b699bbc479f0d",
  measurementId: "G-KF3CBWF5T5",
};

// Initialiser Firebase
const app = initializeApp(firebaseConfig);
const auth: Auth = getAuth(app);

export { auth };
